/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * メディアリストにメディアを追加した時の操作ログとして記録する内容
 * @export
 * @interface AddedMediaOutletsOperationLog
 */
export interface AddedMediaOutletsOperationLog {
    /**
     * メディアリストに対する操作の種類
     * @type {string}
     * @memberof AddedMediaOutletsOperationLog
     */
    actionType: string;
    /**
     * 追加したメディアのidリスト
     * @type {Array<number>}
     * @memberof AddedMediaOutletsOperationLog
     */
    addedMediaOutletIds: Array<number>;
}

export function AddedMediaOutletsOperationLogFromJSON(json: any): AddedMediaOutletsOperationLog {
    return AddedMediaOutletsOperationLogFromJSONTyped(json, false);
}

export function AddedMediaOutletsOperationLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddedMediaOutletsOperationLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actionType': json['action_type'],
        'addedMediaOutletIds': json['added_media_outlet_ids'],
    };
}

export function AddedMediaOutletsOperationLogToJSON(value?: AddedMediaOutletsOperationLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action_type': value.actionType,
        'added_media_outlet_ids': value.addedMediaOutletIds,
    };
}

